import { ClassifyBody } from "pages/VehicleAnalysis/types";

import client from "./client";

export const classifyPhotos = (sessionId: string, clientId: string, body: ClassifyBody) =>
  client.post(`/client/${clientId}/session/${sessionId}/classify`, body, {
    headers: { session_id: sessionId },
  });
